import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_PAGEACTION_TYPE, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/demandEntrySlice";
    import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const DemandMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode,compName, isMultipleCompany } = useSelector((state) => state.company)

    const [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")


    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
    }, [])
    // Fetch shape data
    const {
        data,
        isPending,
        isError,
        mutate: filterData
    } = usePost({
        url: apiRoute.demandMaster.fetch,
        queryKey: "fetchDemandMaster",
    });

    const funLoadData = () => {
        filterData({
            data: { compcode: compCode.join(",") }
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])

    const {
        data: detail = [],
        mutate: funFetDetail
    } = usePostMutateWithSuccess({
        url: apiRoute.demandMaster.fetchEntryDetail,
        queryKey: "fetchDemandDetail",
    });

    const onSuccessDelete = () => {
        setItemToDelete("")
        funLoadData()
    };

    // Delete shape mutation
    const { mutate: fnDelete } = usePost({
        url: apiRoute.demandMaster.deleteEntry,
        queryKey: "deleteDemandMaster",
        onSuccessTasks: onSuccessDelete,
        //successMessage: "Item Group deleted successfully!",
    });

    const exportColumns = [
        {
            name: "Party",
            uid: "PartyName",
        },
        {
            name: "Details",
            uid: "Dem_Details"
        },
        {
            name: "Dem. No NAME",
            uid: "Dem_No",
        },
        {
            name: "Date",
            uid: "Dem_Date",
            type: COLUMN_TYPE.date
        },
    ]

    let downloadDataFooter = {
        PartyName: "",
        Dem_Details: "",
        Dem_No: "",
        Dem_Date: ""
    }
console.log(data)
    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete && itemToDelete != null)
                fnDelete({ data: { transaction_id: itemToDelete, comp_code: compCode.join(",") } });
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                dispatch(setDetailParams(itemToEdit));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.master.demand.createDemandMaster);
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.master.demand.createDemandMaster);
    };

    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Party", uid: "PartyName", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Dem.No", uid: "Dem_No", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Details", uid: "Dem_Details", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.multiline },

        { name: "Date", uid: "Dem_Date", sortable: true, type: COLUMN_TYPE.date, align: COLUMN_ALIGN_TYPE.center },
    ];



 const exportDemandReport = async (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Demand Report");

    const header = data.itemData[0];

    // Company Name
    worksheet.mergeCells("A1:M1");
    worksheet.getCell("A1").value =compName.join(",");
    worksheet.getCell("A1").font = {
        bold: true,
        size: 18,
    };
    worksheet.getCell("A1").alignment = {
        horizontal: "center",
    };

    // Report Name
    worksheet.mergeCells("A2:M2");
    worksheet.getCell("A2").value = `Demand Report (generated On: ${new Date().toLocaleString()})`;
    worksheet.getCell("A2").font = {
        bold: true,
        size: 10,
    };
    worksheet.getCell("A2").alignment = {
        horizontal: "center",
    };

    // Generated On
// const generatedRow = worksheet.addRow([
//     "Generated On",
//     new Date().toLocaleString(),
// ]);

// generatedRow.getCell(1).font = { bold: true };
    worksheet.addRow([]);

    // Main Information
   const row4 = worksheet.addRow([
    "Demand No",
    header.Dem_No,
    "",
    "Date",
    new Date(header.Dem_Date).toLocaleDateString(),
]);

row4.getCell(1).font = { bold: true }; // Demand No
row4.getCell(4).font = { bold: true }; // Date

const row5 = worksheet.addRow([
    "Party",
    header.PartyName,
]);

row5.getCell(1).font = { bold: true }; // Party

    worksheet.addRow([]);

    // Table Header
    worksheet.addRow([
        "Sr No",
        "Location",
        "Shape",
        "Color",
        "Purity",
        "From Size",
        "To Size",
        "From Length",
        "To Length",
        "From Diam",
        "To Diam",
        "Lab",
        // "Flrcn",
        // "Cut",
        // "Polish",
        // "Symmetry",
    ]);

    const headerRow = worksheet.lastRow;

    headerRow.eachCell((cell) => {
        cell.font = {
            bold: true,
            color: {
                argb: "FFFFFFFF",
            },
        };

        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
                argb: "4472C4",
            },
        };

        cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
            bottom: { style: "thin" },
        };

        cell.alignment = {
            horizontal: "center",
            vertical: "middle",
        };
    });

    // Detail Rows
    data.itemDetail.forEach((item, index) => {
        worksheet.addRow([
            index + 1,
            item.Lac_Name,
            item.Shape,
            item.Color,
            item.Purity,
            item.FromSize,
            item.ToSize,
            item.FromLnth,
            item.ToLnth,
            item.FromDiam,
            item.ToDiam,
            item.LabId,
            // item.Flrcn,
            // item.Cut,
            // item.Polish,
            // item.Symtry,
        ]);
    });

    // Border
    worksheet.eachRow((row, rowNumber) => {
        if (rowNumber >= 7) {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    right: { style: "thin" },
                    bottom: { style: "thin" },
                };
            });
        }
    });

    // Column Width
    worksheet.columns = [
        { width: 8 },
        { width: 12 },
        { width: 30 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 10 },
        { width: 12 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(
        new Blob([buffer]),
        `Demand_Report_${header.Dem_No}.xlsx`
    );
};


 const exportDemandSummary = async (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Demand Summary");

    // Company Name
    worksheet.mergeCells("A1:D1");
    worksheet.getCell("A1").value = compName.join(",");
    worksheet.getCell("A1").font = { bold: true, size: 18 };
    worksheet.getCell("A1").alignment = { horizontal: "center" };

    // Report Name
    worksheet.mergeCells("A2:D2");
    worksheet.getCell("A2").value = "Demand Summary Report";
    worksheet.getCell("A2").font = { bold: true, size: 14 };
    worksheet.getCell("A2").alignment = { horizontal: "center" };

    // Generated On
    const generatedRow = worksheet.addRow([
        "Generated On",
        new Date().toLocaleString(),
    ]);
    generatedRow.getCell(1).font = { bold: true };

    worksheet.addRow([]);

    // Header
    const header = worksheet.addRow([
        "Demand No",
        "Demand Date",
        "Party",
        "Demand Details",
    ]);

    header.eachCell((cell) => {
        cell.font = {
            bold: true,
            color: { argb: "FFFFFFFF" },
        };

        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4472C4" },
        };

        cell.alignment = {
            horizontal: "center",
            vertical: "middle",
        };

        cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
            bottom: { style: "thin" },
        };
    });

    data.forEach((item) => {
        const details = item.Dem_Details
            .replace(/<br\s*\/?>/gi, "\n")
            .replace(/ - /g, "• ");

        const row = worksheet.addRow([
            item.Dem_No,
            new Date(item.Dem_Date).toLocaleDateString(),
            item.PartyName,
            details,
        ]);

        row.height = 70;

        row.eachCell((cell) => {
            cell.alignment = {
                vertical: "top",
                wrapText: true,
            };

            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
                bottom: { style: "thin" },
            };
        });
    });

    worksheet.columns = [
        { width: 18 },
        { width: 18 },
        { width: 25 },
        { width: 80 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(
        new Blob([buffer]),
        "Demand_Summary_Report.xlsx"
    );
};
    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    trans_id: row.TransactionId,
                    comp_code: row.CompCode
                };
                setItemToEdit(obj)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete(row.TransactionId)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faFileExcel} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                console.log(row?.CompCode, row?.TransactionId)
                funFetDetail(
                    {
                        data: {
                            compcode: row?.CompCode,
                            transactionid: row?.TransactionId
                        },
                        onSuccess: (data) => {
                            exportDemandReport(data)
                        }
                    })
            },
            type: ROW_ACTION_BTN_TYPE.button,
            label: "Excel"
        },
    ];

    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <div>
            <MainContainer pageName="Demand Master" breadcrumbs={["Mater", "Demand Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                     <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Demand Summary
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "PartyName", "Dem_No", "Dem_Details", "Dem_Date"]}
                    data={data}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    showAdvanceFilter={false}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="Demand-master-List"
                    id="TransactionId"

                />
            </MainContainer>


            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}
        </div>
    );
};

export default DemandMaster;
